import { render, staticRenderFns } from "./new.chats.page.vue?vue&type=template&id=b2046298&"
import script from "./new.chats.page.vue?vue&type=script&lang=js&"
export * from "./new.chats.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports